import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { React, useEffect } from "react";
import { sizes } from "../approvalUtils";
import { useDispatch, useSelector } from "react-redux";
import { getScenariosForApproval, setState } from "./scenarioApprovalSlice";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

export default function Form() {
  const { paramsCountryID } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const state = useSelector((state) => state.scenarioApproval);
  const {
    searchText,
    countries,
    selectedCountry,
    selectedCountryID,
    scenarioStatusList,
    selectedScenarioStatus,
    periods,
    selectedPeriod,
    navigatedCountryID,
  } = state;

  const loginState = useSelector((store) => store.login);
  const { globalSelectedCountryName,globalSelectedCountryID,} = loginState   
  
  useEffect(() => {
    if(globalSelectedCountryName !==null && globalSelectedCountryName !== "" ){
        dispatch(setState("selectedCountry", globalSelectedCountryName));
        dispatch(setState("selectedCountryID", globalSelectedCountryID));
        dispatch(setState("SAGlobalCountryID", globalSelectedCountryID));
    }
    else{
      dispatch(setState("selectedCountry", ""));
      dispatch(setState("selectedCountryID", ""));
      dispatch(setState("SAGlobalCountryID", ""));
    }
}, [globalSelectedCountryID]);     

	useEffect(() => {
		if (location.state) {
      //console.log("Scenario", location.state);
			dispatch(setState("selectedCountry", location.state.selectedCountry));
			dispatch(setState("selectedCountryID", location.state.selectedCountryID));
      // API call
      const logedUser = JSON.parse(localStorage.getItem("data"));
      const obj = {
        countryId: location.state.selectedCountryID,
        logedUser,
        period: selectedPeriod,
        scenarioStatus: selectedScenarioStatus,
        searchText,
      };
      dispatch(getScenariosForApproval(obj));
		}
	}, [location]);

  function setSearchText(event) {
    const text = event.target.value;
    dispatch(setState("searchText", text));
  }

  function setCountry(event) {
    dispatch(setState("scenarioDetails", null));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRows", []));
    dispatch(setState("scenariosForApproval", null));
    dispatch(setState("scenariosForApprovalTable", null));
    dispatch(setState("navigatedCountryID", ""));

    const name = event.target.value;
    let id = 0;
    if (name !== "All") {
      id = countries.find((country) => country.countryName === name).countryID;
    }

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", id));
  }

  function setScenarioStatus(event) {
    dispatch(setState("scenarioDetails", null));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRows", []));
    dispatch(setState("scenariosForApproval", null));
    dispatch(setState("scenariosForApprovalTable", null));
    const status = event.target.value;
    dispatch(setState("selectedScenarioStatus", status));
  }

  function setPeriod(event) {
    dispatch(setState("scenarioDetails", null));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRows", []));
    dispatch(setState("scenariosForApproval", null));
    dispatch(setState("scenariosForApprovalTable", null));
    const period = event.target.value;
    dispatch(setState("selectedPeriod", period));
  }
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  function search() {
    if (selectedScenarioStatus === null || selectedScenarioStatus === "") {
      showMessage("Please select scenario status", "info");
      return;
    } else if (selectedCountryID === null || selectedCountryID === "") {
      showMessage("Please select country", "info");
      return;
    } else if (selectedPeriod === null || selectedPeriod === "") {
      showMessage("Please select period", "info");
      return;
    }
    dispatch(setState("scenarioDetails", null));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRows", []));
    const logedUser = JSON.parse(localStorage.getItem("data"));
    const period = selectedPeriod;
    const scenarioStatus = selectedScenarioStatus;
    const countryId = selectedCountryID;

    const obj = {
      countryId,
      logedUser,
      period,
      scenarioStatus,
      searchText,
    };
    dispatch(getScenariosForApproval(obj));
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Grid container columns={12} columnGap={2} rowGap={2}>
        <Grid item sm={2} xs={12}>
          <FormControl>
            <InputLabel>Scenario Status</InputLabel>
            <Select
              value={selectedScenarioStatus}
              label="Scenario Status"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setScenarioStatus}
            >
              {scenarioStatusList.map((status, index) => {
                return (
                  <MenuItem key={index} value={status.value}>
                    {status.value}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sm={2} xs={12}>
          <FormControl>
            <InputLabel>Country</InputLabel>
            <Select
              value={selectedCountry}
              label="Country"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setCountry}
            >
              <MenuItem value={"All"}>{"All"}</MenuItem>
              {countries.map((country, index) => {
                return (
                  <MenuItem key={index} value={country.countryName}>
                    {country.countryName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sm={2} xs={12}>
          <FormControl>
            <InputLabel>Period</InputLabel>
            <Select
              value={selectedPeriod}
              label="Value"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setPeriod}
            >
              {periods.map((period, index) => {
                return (
                  <MenuItem key={index} value={period.value}>
                    {period.value}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sm={4.7} xs={12}>
          <TextField
            placeholder="Type your search"
            inputProps={{
              sx: {
                p: 2,
                width: selectWidth,
                height: selectHeight,
              },
            }}
            value={searchText}
            onChange={setSearchText}
          />
        </Grid>

        <Grid item sm={0.8} xs={12}>
          <Button
            startIcon={<ManageSearchIcon />}
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              "&:hover": {
                bgcolor: "darkred.main",
                color: "white.main",
              },
            }}
            onClick={search}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
